import { render, staticRenderFns } from "./articleDialog.vue?vue&type=template&id=59f3cd81&scoped=true&"
import script from "./articleDialog.vue?vue&type=script&lang=js&"
export * from "./articleDialog.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./articleDialog.vue?vue&type=style&index=1&id=59f3cd81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f3cd81",
  null
  
)

export default component.exports